/* eslint-disable no-else-return */
// import { Toast } from 'antd-mobile';
import { DefaultMockHead, DefaultApiHead } from '../fetchEnv';
import { getLoginToken, handleInvalidToken } from '../../utils/LoginToken';

import ApiLogin from './apiLogin';
import ApiDealCenter from './apiDealCenter';
import ApiDownload from './apiDownload';
import ApiManageOperator from './apiManageOperator';

export const getPubData = () => {
  return JSON.stringify({ c: 'H5', b: 'MERCHANT-WEBSITE', id: '102', t: new Date() });
};

console.log(DefaultApiHead);
// 基础配置
export const BaseConfig = {
  url: '', // 接口url
  method: 'post', // 请求类型
  commonParams: {}, // 通用参数
  baseUrl: DefaultApiHead, // url头部
  apiBaseUrl: DefaultApiHead,
  mockBaseUrl: DefaultMockHead,
  openMock: false, // 是否开启mock
  successCode: '00', // 请求成功code
  validTokenCode: { // token失效code
    '01': true,
    '03': true,
    '04': true,
  },
  handleInvalidToken: (data) => { handleInvalidToken(); }, // 处理token失效
  headers: {},
  getHeaders: () => ({
    'Content-Type': 'application/json;charset=UTF-8',
    Authorization: getLoginToken(),
    pubData: getPubData(),
  }),
  reqStart: () => { }, // 请求开始
  reqEnd: () => { }, // 请求结束
  handleError: () => { }, // 请求异常
  timeoutMs: 15000, // 超时
  isFormData: false,
  isUrl: false,
};

// 接口配置
export const ApiConfig = {
  ...ApiLogin,
  ...ApiDealCenter,
  ...ApiDownload,
  ...ApiManageOperator,
};



// WEBPACK FOOTER //
// ./src/service/apiConfig/index.js